import { type StoreChatItem } from '@atlassian/conversation-assistant-store/controllers/chat/types';

import { type AnswerUiSlotUpdate } from './answer-ui-parts';
import { updateStoreAssistant } from './updateStoreAssistant';

/**
 * Sets, rather than appends to, Answer UI slots and their `-loading` flags.
 * `addAnswerPartWithMarkdownDataMap` appends, so it can't fill a slot placed earlier.
 */
export const setAnswerUiSlots = ({
	chat,
	answerId,
	updates,
	useIndex,
}: {
	chat: StoreChatItem[];
	answerId: string;
	updates: AnswerUiSlotUpdate[];
	useIndex?: number;
}): StoreChatItem[] => {
	if (updates.length === 0) {
		return chat;
	}
	return updateStoreAssistant({
		chat,
		promptId: answerId,
		updateFunction: (storeAssistant) => {
			const markdownData = { ...storeAssistant.markdownData };
			for (const { key, content, loading } of updates) {
				markdownData[key] = content;
				markdownData[`${key}-loading`] = loading ? 'true' : 'false';
			}
			return { ...storeAssistant, markdownData };
		},
		updateType: 'Set Answer UI Slots',
		useIndex,
	});
};
